import React, { useState } from "react";
import ReactCardFlip from "react-card-flip";

export const CARD_MIN_WIDTH = 200;
export const CARD_MAX_WIDTH = 300;

function CardBase({ src, onClick }) {
  return (
    <img
      src={src}
      alt="card"
      onClick={onClick}
      style={{ maxWidth: "100%", borderRadius: 40 }}
    />
  );
}

export default function Card({ sideA, sideB }) {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div
      style={{
        flex: 1,
        minWidth: CARD_MIN_WIDTH,
        maxWidth: CARD_MAX_WIDTH,
        margin: 10
      }}
    >
      <ReactCardFlip isFlipped={isFlipped}>
        <CardBase src={sideA} onClick={() => setIsFlipped(!isFlipped)} />
        <CardBase src={sideB} onClick={() => setIsFlipped(!isFlipped)} />
      </ReactCardFlip>
    </div>
  );
}
